var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace2Right(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 997.8 926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #42210b;\n      }\n\n      .cls-4 {\n        fill: #f44d41;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M343.96,0h266.26C800.06,0,954.18,154.12,954.18,343.96v104.95c0,263.31-213.78,477.09-477.09,477.09h0C213.78,926,0,712.22,0,448.91v-104.95C0,154.12,154.12,0,343.96,0Z",
    transform: "translate(954.18 926) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 274.35,
    cy: 586.58,
    r: 120.78
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M796.2,679.08h.02c5.68-1.65,11.79,1.12,14.06,6.57,13.57,32.63,45.19,55.4,80.06,56.56,8.91.29,17.63-.82,25.96-3.13-4.66,9.07-9.73,17.89-15.15,26.47-2.64.19-5.29.3-7.96.3-1.21,0-2.42-.02-3.63-.06-44.74-1.48-83.88-29.43-101.01-70.85-2.69-6.5.88-13.91,7.64-15.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 670.3,
    cy: 459.67,
    rx: 108.17,
    ry: 110.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M556.11,459.67c0-64.36,51.22-116.72,114.18-116.72s114.18,52.36,114.18,116.72c0,64.36-51.22,116.72-114.18,116.72s-114.18-52.36-114.18-116.72ZM568.13,459.67c0,57.73,45.83,104.7,102.16,104.7,56.33,0,102.16-46.97,102.16-104.7,0-57.73-45.83-104.7-102.16-104.7-56.33,0-102.16,46.97-102.16,104.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 708.17,
    cy: 459.94,
    rx: 66.75,
    ry: 68.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M635.42,459.94c0-40.98,32.64-74.32,72.75-74.32s72.76,33.34,72.76,74.32-32.64,74.32-72.76,74.32-72.75-33.34-72.75-74.32ZM647.44,459.94c0,34.35,27.24,62.3,60.73,62.3s60.74-27.95,60.74-62.3c0-34.35-27.25-62.3-60.74-62.3s-60.73,27.95-60.73,62.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M588.14,335.53c8.95-7.91,41.73-33.51,87.79-30.56,35.79,2.26,60.79,20.1,72.5,30.54l7.99-8.98c-12.87-11.47-40.35-31.07-79.74-33.56-49.35-3.11-83.92,22.42-96.51,33.55l7.96,9.01Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 884.05,
    y: 548.23,
    width: 113.76,
    height: 77.19,
    rx: 38.6,
    ry: 38.6,
    transform: "translate(1881.85 1173.65) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace2Right);
export default __webpack_public_path__ + "static/media/face2-right.3377c4d667399ac64b5db4d8ee228a29.svg";
export { ForwardRef as ReactComponent };